import ChipState from '../../../../components/Chips/ChipState'
import { MdInfo, MdOutlineShare } from "react-icons/md";
import { useState } from 'react';
import Dialog from '../../../../components/Dialog/Dialog';
import Share from '../../../../components/Share/Share';
import { ODSPriorityGroups } from '../../../../interfaces/Indicator';
import BreadcrumbTitle from './common/BreadcrumbTitle';
import MethodologyNoteDialog from './common/MethodologyNoteDialog';
import OdsChips from '../../../../components/Mappers/OdsChips';
import PriorityGroupChips from '../../../../components/Mappers/PriorityGroupsChips';
import { useHighlightText } from '../../hooks/useHighlightText';
import Button from '../../../../components/Buttons/Button';
import { buildHrefFromBreadcrumbs } from '../../utils/buildShareHref';

interface IHeaderIndicator {
    breadcrumbs: string;
    titulo: string;
    descripcion: string;
    notas: string;
    documento_informativo: string;
    state: number | null;
    id: number;
    ods: ODSPriorityGroups[];
    priorityGroups: ODSPriorityGroups[];
    dimension: { id: number; titulo: string };
    subdimension: { id: number; titulo: string };
}

const HeaderIndicator = ({ breadcrumbs, titulo, descripcion, notas, documento_informativo, state, id, ods, priorityGroups, dimension, subdimension }: IHeaderIndicator) => {
    const { highlight } = useHighlightText();

    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [isOpenMetodologyNote, setIsOpenMetodologyNote] = useState<boolean>(false);

    const href = buildHrefFromBreadcrumbs(breadcrumbs, id, dimension, subdimension, { addFilterApplied: true });

    return (
        <>
            <BreadcrumbTitle titulo={titulo} breadcrumbs={breadcrumbs} />
            <div className='flex flex-col md:flex-row gap-6 md:gap-0 justify-between'>
                <h2 className='text-brand-green-20 text-hlarge'>
                    {highlight(titulo)}
                </h2>
                <div className='flex justify-between gap-2'>
                    <ChipState
                        state={state}
                    />
                    <div className='flex gap-2'>
                        <Button
                            icon={MdOutlineShare}
                            onClick={() => setIsOpen(!isOpen)}
                            label=""
                            iconSize={22}
                            variant='outline'
                            showIconLeft={true}
                            showIconRight={false}
                            className='!px-3'
                        />
                        <Button
                            icon={MdInfo}
                            onClick={() => setIsOpenMetodologyNote(!isOpenMetodologyNote)}
                            label=""
                            iconSize={22}
                            variant='outline'
                            showIconLeft={true}
                            showIconRight={false}
                            className='!px-3'
                        />
                    </div>
                </div>
            </div>
            <span className='text-system-light-40 text-blarge'>
                {highlight(descripcion)}
            </span>
            <div className='flex flex-col gap-2'>
                <PriorityGroupChips groups={priorityGroups} />
                <OdsChips ods={ods} />
            </div>
            <Dialog
                isOpen={isOpen}
                toggle={() => setIsOpen(!isOpen)}
                bgColor="bg-brand-green-5"
            >
                <Share newsTitle={`Indicador de ${titulo}`} newsUrl={href} description={descripcion} />
            </Dialog>
            <MethodologyNoteDialog
                isOpen={isOpenMetodologyNote}
                toggle={() => setIsOpenMetodologyNote(!isOpenMetodologyNote)}
                notas={notas}
                documento_informativo={documento_informativo}
            />
        </>
    )
}

export default HeaderIndicator